import { Button, ButtonTheme } from '@apply/components';
import { useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

interface BackButtonProps {
    experienceId: string | undefined;
    required?: boolean;
    readOnly?: boolean;
}

export const BackButton: React.FC<BackButtonProps> = ({ experienceId }) => {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const handleBackButtonClick = () => {
        queryClient.removeQueries({ queryKey: ['userExperience'] });
        navigate('/experience');
        window.scrollTo(0, 0);
    };
    return (
        <>
            <Button
                id='cancelExperienceButton'
                theme={ButtonTheme.LinkBlue}
                handleClick={() => handleBackButtonClick()}
            >
                <FontAwesomeIcon icon={faChevronLeft} />
                Back
            </Button>
        </>
    );
};
